/**
 * Bestseller-Aktions-Popup.
 * Baut auf ModalDialog (global.js) und den Cookie-Helfern (cookies.js) des Themes auf.
 */
class VwBestsellerPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  init() {
    this.delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;
    this.scrollPercent = parseInt(this.dataset.scroll, 10) || 0;
    this.frequencyDays = parseInt(this.dataset.days, 10) || 0;
    this.cookieName = this.dataset.cookie || "vw-bestseller-popup-closed";
    this.opened = false;
  }

  attachEventListeners() {
    const dismiss = this.querySelector(".js-button-close");
    if (dismiss) {
      dismiss.addEventListener("click", this.closePopup.bind(this));
    }

    const closeIcon = this.querySelector('[id^="ModalClose-"]');
    if (closeIcon) {
      closeIcon.addEventListener("click", this.rememberClose.bind(this));
    }

    const copyButton = this.querySelector(".js-copy-code");
    if (copyButton) {
      copyButton.addEventListener("click", this.copyCode.bind(this, copyButton));
    }

    const cta = this.querySelector(".js-cta");
    if (cta) {
      // Klick auf den CTA gilt als gesehen, damit es nach der Rueckkehr nicht erneut aufgeht.
      cta.addEventListener("click", this.rememberClose.bind(this));
    }
  }

  rememberClose() {
    if (this.frequencyDays > 0) {
      setCookie(this.cookieName, "true", this.frequencyDays);
    } else {
      setCookie(this.cookieName, "true");
    }
  }

  closePopup() {
    this.rememberClose();
    this.hide();
  }

  copyCode(button) {
    const source = this.querySelector(".vw-bsp__code-value");
    if (!source) return;

    const code = source.textContent.trim();
    const label = button.dataset.label || button.textContent.trim();
    button.dataset.label = label;

    const confirm = () => {
      button.textContent = button.dataset.copiedLabel || "Kopiert";
      setTimeout(() => {
        button.textContent = label;
      }, 1800);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(confirm, confirm);
      return;
    }

    const helper = document.createElement("input");
    helper.value = code;
    document.body.appendChild(helper);
    helper.select();
    try {
      document.execCommand("copy");
    } catch (error) {
      // Kopieren nicht moeglich - Code steht sichtbar im Popup.
    }
    document.body.removeChild(helper);
    confirm();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    // ?vw_popup=on erzwingt die Anzeige - ignoriert Cookie und Verzoegerung, fuer Tests.
    if (/[?&]vw_popup=on/.test(window.location.search)) {
      this.openOnce();
      return;
    }

    if (getCookie(this.cookieName) === "true") return;
    if (/[?&]vw_popup=off/.test(window.location.search)) return;

    this.watchTriggers();
  }

  watchTriggers() {
    if (this.delay > 0 || this.scrollPercent === 0) {
      setTimeout(this.openOnce.bind(this), this.delay);
    }

    if (this.scrollPercent > 0) {
      this.onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0) return;
        if ((window.scrollY / max) * 100 >= this.scrollPercent) {
          this.openOnce();
        }
      };
      window.addEventListener("scroll", this.onScroll, { passive: true });
    }
  }

  openOnce() {
    if (this.opened) return;

    // Der Altersnachweis hat Vorrang - danach erneut versuchen.
    if (document.body.classList.contains("age-verification-popup-is-open")) {
      document.body.addEventListener("modalClosed", this.openOnce.bind(this), { once: true });
      return;
    }

    this.opened = true;
    if (this.onScroll) window.removeEventListener("scroll", this.onScroll);
    this.show();
  }
}

customElements.define("vw-bestseller-popup", VwBestsellerPopup);
